export default {
  "contact.hero.breadcrumb_home": "Home",
  "contact.hero.breadcrumb_contact": "Contact",
  "contact.hero.title": "Contact",
  "contact.hero.description_line1": "Do you have questions or want to collaborate with FOPMN?",
  "contact.hero.description_line2": "Don't hesitate to contact us.",

  "contact.legal.title": "Official Legal Identification Data",
  "contact.legal.name_label": "Full Name",
  "contact.legal.name": "FEDERATION OF FISHERMEN'S ORGANIZATIONS OF THE BLACK SEA",
  "contact.legal.name_desc": "Umbrella-type associative entity, representative of the commercial fishing sector.",
  "contact.legal.fiscal_label": "Fiscal Identification",
  "contact.legal.fiscal_registered": "Registered in accordance with Romanian legislation.",
  "contact.legal.fiscal_activity": "Activities of professional organizations",
  "contact.legal.bank_label": "Banking Details",
  "contact.legal.bank": "BRD - Groupe Société Générale (Constanța County Unit)",
  "contact.legal.bank_purpose": "Payment of membership fees, sponsorships and project support funds.",

  "contact.intro.title": "Contact",
  "contact.intro.text": "Whether you are a professional fisherman seeking support, a representative of a public institution or a commercial partner, the FOPMN team is at your disposal for legislative clarifications, technical assistance and strategic collaborations. Use the form below to send us your message or contact us directly through the official communication channels. We guarantee a fast evaluation and a well-founded response from our specialists.",

  "contact.info.title": "Contact Information",
  "contact.info.address": "Address",
  "contact.info.address_value": "11 Smaraldului St., Apt. 6, Constanța, Constanța County, Postal Code: 900001, Romania",
  "contact.info.president": "President",
  "contact.info.secretary": "Secretary",
  "contact.info.schedule": "Schedule",
  "contact.info.schedule_value": "Monday – Friday: 09:00 – 17:00",

  "contact.form.title": "Send Us a Message",
  "contact.form.name": "Name *",
  "contact.form.name_placeholder": "Your name",
  "contact.form.email": "Email *",
  "contact.form.email_placeholder": "email@example.com",
  "contact.form.phone": "Phone",
  "contact.form.phone_placeholder": "+40 7XX XXX XXX",
  "contact.form.subject": "Subject *",
  "contact.form.subject_select": "Select subject",
  "contact.form.subject_affiliation": "Organization Affiliation",
  "contact.form.subject_sponsorship": "Sponsorship",
  "contact.form.subject_programs": "Program Information",
  "contact.form.subject_collaboration": "Collaboration",
  "contact.form.subject_press": "Press",
  "contact.form.subject_other": "Other",
  "contact.form.message": "Message *",
  "contact.form.message_placeholder": "Write your message...",
  "contact.form.consent": "I agree to the processing of my personal data for the purpose of resolving this request, according to the terms stipulated in the",
  "contact.form.consent_link": "Privacy Policy",
  "contact.form.consent_suffix": "of FOPMN*",
  "contact.form.consent_error": "You must accept data processing to send the message.",
  "contact.form.submit": "Send Message",
  "contact.form.submitting": "Sending...",

  "contact.success.title": "Message sent successfully!",
  "contact.success.text": "Thank you for your message. We will get back to you as soon as possible.",
  "contact.success.new": "Send another message",
};